export const halalStates = [
    'FULL_HALAL',
    'PARTIAL_HALAL',
  ];

export const PARTIAL_HALAL = "PARTIAL_HALAL";
export const FULL_HALAL = "FULL_HALAL";